import { keywordSearch } from "./keywordSearch";


export function attachSearchEvent()
{
    $("input[value='Search']").on('click', function(e:any)
    {
        e.preventDefault();
        keywordSearch();
    });
	const getSearchButtons = () => document.querySelectorAll("input[value='Search']");
    const searchValue = $('#inputCare').val() as string;

	getSearchButtons().forEach((button) => {
        if(!searchValue)
        $("input[value='Search']").attr('disabled', 'disabled');
        button.addEventListener("click", () => keywordSearch());
    });
	
    $('#inputCare').keyup(function (e:any)
    {
		getSearchButtons().forEach((button) => {
            $("input[value='Search']").attr('disabled', !e.target.value);
        });
       
        const searchRegex = /^[a-zA-Z0-9-\s]+$/g;
        if (searchRegex.test(e.target.value))
        {
            const errMsg = document.querySelector('#searchInputErrMsg');
            if (errMsg)
                $('#searchInputErrMsg').remove();
        }
        if ($('#inputCare').is(":focus") && e.key == "Enter")
        {
            keywordSearch();
        }
    });
}
